<template>
  <div class="main-content">
    <div class="page-content">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-flex align-items-center justify-content-between">
            <h4 class="page-title mb-0 font-size-18">Dashbaord</h4>
            <div class="page-title-right">

            </div>
          </div>
        </div>
      </div>
      <!-- content -->
      <div class="row" v-if="$store.state.users.id === 114">
        <div class="col-4 col-md-4">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4 font-size-15 text-center color-gray">Versionamento de peças</h4>
              <AppChart :chart-data="barData" :options="barOptions" />
            </div>
          </div>
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4 font-size-15 text-center color-gray">Versionamento de peças</h4>
              <AppChart :chart-data="barData" :options="barOptions" />
            </div>
          </div>
        </div>
        <div class="col-4 col-md-4">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title mb-4 font-size-15 text-center color-gray">Versionamento de peças templatizadas</h4>
              <AppChart :chart-data="barData" :options="barOptions" />
            </div>
          </div>
        </div>
        <div class="col-4 col-md-4">
          <div class="row">
            <div class="col-4">
              <div class="card">
                <div class="card-body text-center">
                  <h4 class="font-size-15 color-gray">Volume de peças</h4>
                  <h4 class="card-number">1,368</h4>
                  <div class="row">
                    <div class="col-6 text-right pr-0">
                      <p class="mb-0"><span class="text-success me-2"> 0.28% <i class="mdi mdi-arrow-up"></i> </span>
                      </p>
                    </div>
                    <div class="col-6 text-left pr-0 pl-0">
                      <p class="mb-0 color-gray">Mês anterior</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="card">
                <div class="card-body text-center">
                  <h4 class="font-size-15 color-gray">Volume de peças</h4>
                  <h4 class="card-number">1,368</h4>
                  <div class="row">
                    <div class="col-6 text-right pr-0">
                      <p class="mb-0"><span class="text-success me-2"> 0.28% <i class="mdi mdi-arrow-up"></i> </span>
                      </p>
                    </div>
                    <div class="col-6 text-left pr-0 pl-0">
                      <p class="mb-0 color-gray">Mês anterior</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4">
              <div class="card">
                <div class="card-body text-center">
                  <h4 class="font-size-15 color-gray">Volume de peças</h4>
                  <h4 class="card-number">1,368</h4>
                  <div class="row">
                    <div class="col-6 text-right pr-0">
                      <p class="mb-0"><span class="text-success me-2"> 0.28% <i class="mdi mdi-arrow-up"></i> </span>
                      </p>
                    </div>
                    <div class="col-6 text-left pr-0 pl-0">
                      <p class="mb-0 color-gray">Mês anterior</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4 mt-4">
              <div class="card">
                <div class="card-body text-center">
                  <h4 class="font-size-15 color-gray">Volume de peças</h4>
                  <h4 class="card-number">1,368</h4>
                  <div class="row">
                    <div class="col-6 text-right pr-0">
                      <p class="mb-0"><span class="text-success me-2"> 0.28% <i class="mdi mdi-arrow-up"></i> </span>
                      </p>
                    </div>
                    <div class="col-6 text-left pr-0 pl-0">
                      <p class="mb-0 color-gray">Mês anterior</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4 mt-4">
              <div class="card">
                <div class="card-body text-center">
                  <h4 class="font-size-15 color-gray">Volume de peças</h4>
                  <h4 class="card-number">1,368</h4>
                  <div class="row">
                    <div class="col-6 text-right pr-0">
                      <p class="mb-0"><span class="text-success me-2"> 0.28% <i class="mdi mdi-arrow-up"></i> </span>
                      </p>
                    </div>
                    <div class="col-6 text-left pr-0 pl-0">
                      <p class="mb-0 color-gray">Mês anterior</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4 mt-4">
              <div class="card">
                <div class="card-body text-center">
                  <h4 class="font-size-15 color-gray">Volume de peças</h4>
                  <h4 class="card-number">1,368</h4>
                  <div class="row">
                    <div class="col-6 text-right pr-0">
                      <p class="mb-0"><span class="text-success me-2"> 0.28% <i class="mdi mdi-arrow-up"></i> </span>
                      </p>
                    </div>
                    <div class="col-6 text-left pr-0 pl-0">
                      <p class="mb-0 color-gray">Mês anterior</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4 mt-4">
              <div class="card">
                <div class="card-body text-center">
                  <h4 class="font-size-15 color-gray">Volume de peças</h4>
                  <p class="font-size-12  mb-0">Concluído*</p>
                  <h4 class="card-number">1,368</h4>
                  <div class="row">
                    <div class="col-6 text-right pr-0">
                      <p class="mb-0"><span class="text-success me-2"> 0.28% <i class="mdi mdi-arrow-up"></i> </span>
                      </p>
                    </div>
                    <div class="col-6 text-left pr-0 pl-0">
                      <p class="mb-0 color-gray">Mês anterior</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4 mt-4">
              <div class="card">
                <div class="card-body text-center">
                  <h4 class="font-size-15 color-gray">Volume de peças</h4>
                  <p class="font-size-12  mb-0">Concluído*</p>
                  <h4 class="card-number">1,368</h4>
                  <div class="row">
                    <div class="col-6 text-right pr-0">
                      <p class="mb-0"><span class="text-success me-2"> 0.28% <i class="mdi mdi-arrow-up"></i> </span>
                      </p>
                    </div>
                    <div class="col-6 text-left pr-0 pl-0">
                      <p class="mb-0 color-gray">Mês anterior</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4 mt-4">
              <div class="card">
                <div class="card-body text-center">
                  <h4 class="font-size-15 color-gray">Volume de peças</h4>
                  <p class="font-size-12  mb-0">Concluído*</p>
                  <h4 class="card-number">1,368</h4>
                  <div class="row">
                    <div class="col-6 text-right pr-0">
                      <p class="mb-0"><span class="text-success me-2"> 0.28% <i class="mdi mdi-arrow-up"></i> </span>
                      </p>
                    </div>
                    <div class="col-6 text-left pr-0 pl-0">
                      <p class="mb-0 color-gray">Mês anterior</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppChart from "@/components/Charts/Chart.vue"
export default {
  components: {
    AppChart
  },
  data() {
    return {
      barData: {
        labels: ["V1", "V2", "V3", "V4"],
        datasets: [
          {
            label: "Versionamento de peças",
            data: [10, 20, 30, 40],
            backgroundColor: [
              '#3b5de7',
              '#5f80ec',
              '#263ea1',
              '#bac8f6',
              '#3bd0e7',
              '#7b3be7',
              '#1939bf'
            ]
          }
        ]
      },
      barOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: { position: 'left' },
        plugins: {
          datalabels: {
            color: "#fff",
            font: { size: 18 },
            formatter: (value, context) => {
              const data = context.chart.data.datasets[0].data;
              const total = data.reduce((acc, val) => acc + val, 0);
              const pct = total ? (value / total * 100) : 0;
              return pct.toFixed(1) + "%";
            }
          }
        }
      }
    }
  }
};
</script>